import e, { useRef as t } from "react";
import a from "../../../../node_modules/classnames/index.js";
import n from "../../general/TextTruncate/TextTruncate.js";
function r(r) {
  var m = r.app,
    p = a("app-launcher-item", "app-launcher-item--" + m.productId.replace(/[^a-zA-Z0-9-]/g, "")),
    l = t(null);
  return e.createElement("div", {
    ref: l,
    className: p
  }, e.createElement("a", {
    href: m.landingPageUrl,
    target: "_blank"
  }, e.createElement("img", {
    src: m.productImageUrl,
    className: "app-launcher-item__icon"
  }), e.createElement("div", {
    className: "app-launcher-item__text"
  }, m.isPinned ? e.createElement(n, {
    maxLines: 2,
    className: "app-launcher-item__name",
    text: m.name,
    tooltipOptions: {
      position: "bottom",
      target: l.current,
      className: "app-launcher-item-tooltip"
    }
  }) : e.createElement(e.Fragment, null, e.createElement("span", {
    className: "app-launcher-item__name"
  }, m.name), e.createElement(n, {
    className: "app-launcher-item__description",
    text: m.description,
    tooltipOptions: {
      position: "bottom",
      target: l.current,
      className: "app-launcher-item-tooltip"
    }
  })))));
}
r.displayName = "AppLauncherItem";
export { r as AppLauncherItem };